import React from 'react';
import { connect } from 'react-redux';

import releaseNotesSelector from 'Selectors/releaseNotesSelector';

import { whatReleaseNotes, resetReleaseNotes } from 'Actions/ReleaseNotesActions';
import { resetInfinite } from 'Actions/InfiniteScrollActions';
import { trackPageView, onPageView } from 'Actions/adsActions';
import { pingServer } from 'Actions/GlobalMetaActions';

import InfiniteScroll from 'Components/infiniteScroll/InfiniteScrollComponent';
import ReleaseNotesListComponent from 'Components/releasenotes/ReleaseNotesListComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

export class ReleaseNotesViewComponent extends React.Component {
	get releaseNotes() {
		return this.props.releaseNotes.result;
	}

	componentWillUnmount() {
		this.props.dispatch( resetInfinite() );
		this.props.dispatch( resetReleaseNotes() );
	}

	componentDidMount() {
		let page = this.props.location.query.page || 1;
		this.loadPage( page );
	}

	componentWillReceiveProps(nextProps) {
		if( nextProps.releaseNotes.loaded && nextProps.releaseNotes.loaded !== this.props.releaseNotes.loaded ) {
			// trigger ad updates
			this.props.dispatch( onPageView() );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
			// Ping server for user info
			this.props.dispatch( pingServer() );
		}
	}

	releaseNotesList = () => {
		const { isFetching } = this.props.releaseNotes;
		if( this.releaseNotes.length !== 0 ) {
			return (
				<InfiniteScroll
					scrollRef={ i => this.infiniteScroll = i }
					isFetching={isFetching}
					loadPage={this.loadPage}
					location={this.props.location}>
					<ReleaseNotesListComponent />
				</InfiniteScroll>
			)
		} else {
			return <div>Unable to retrieve release notifications</div>
		}
	};

	loadPage = ( pageNum ) => {
		this.props.dispatch( whatReleaseNotes( pageNum ) );
	};

	render() {
		if( !this.props.releaseNotes.loaded ) {
			return <LoaderCss />;
		}

		return (
			<div>
				{ this.releaseNotesList() }
			</div>
		);
	}
}

export default connect( releaseNotesSelector )( ReleaseNotesViewComponent );



// WEBPACK FOOTER //
// ./src/components/ReleaseNotesViewComponent.js